import { z } from "zod";
import { timestampSchema } from "../common.js";
/**
 * Deposit requests (owner request, 17 October 2026): a PA asks a lead for a deposit from the lead
 * page and sends the pay link on WhatsApp or by email. The patient pays on the widget's pay page
 * into the clinic's own Stripe account (direct charge, as for paid appointments, 11.3).
 * `clinics/{clinicId}/depositRequests/{id}`: written by functions only, read by staff.
 * Unpaid requests never expire and never cancel the appointment by themselves (owner decision,
 * 17 October 2026): the team decides.
 */
export const DEPOSIT_STATUSES = ["requested", "paid", "cancelled", "refunded"];
export const depositStatusSchema = z.enum(DEPOSIT_STATUSES);
export const depositRequestSchema = z.object({
    leadId: z.string(),
    leadRef: z.string(),
    appointmentId: z.string().optional(),
    /** Minor units (pence). */
    amount: z.number().int().min(100).max(1_000_000),
    currency: z.string().length(3),
    description: z.string().max(200).optional(),
    status: depositStatusSchema,
    /** How the link went out first: the WhatsApp chat the PA opened, or our email. */
    channel: z.enum(["whatsapp", "email"]),
    /** The pay page link (carries the token; staff may copy or resend it). */
    url: z.string().max(2048),
    createdBy: z.string(),
    createdByName: z.string().max(120).optional(),
    impersonatedBy: z.string().optional(),
    createdAt: timestampSchema,
    emailedAt: timestampSchema.optional(),
    paymentIntentId: z.string().optional(),
    paidAt: timestampSchema.optional(),
    cancelledAt: timestampSchema.optional(),
    refundedAt: timestampSchema.optional(),
});
/** `payLinks/{sha256(token)}`: server-only lookup from a pay link to its request. */
export const payLinkSchema = z.object({
    clinicId: z.string(),
    requestId: z.string(),
    createdAt: timestampSchema,
});
/** On the lead, for lists and the lead page: the latest deposit request. */
export const leadDepositSchema = z.object({
    requestId: z.string(),
    status: depositStatusSchema,
    amount: z.number().int(),
    currency: z.string().length(3),
    at: timestampSchema,
});
//# sourceMappingURL=deposit.js.map